import Icon from 'veui/components/Icon'
import { IconSave } from 'dls-icons-vue'

Icon.register('save', IconSave)
